import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DocumentTitle from '../../components/DocumentTitle';
import { destructServerErrors, hasError, getError } from '../../helpers/error';
import __ from '../../helpers/translation';
import FormError from '../../components/partials/FormError';
import api from '../../actions/api';
import PropTypes from 'prop-types';

const propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

class ResetPassword extends Component {
  constructor (props) {
    super(props);
    this.state = {
      'email': '',
      'password': '',
      'password_confirmation': '',
      'token': '',
      'errors': '',
      'resetMessage': ''
    };
  }

  handleSubmit (e) {
    e.preventDefault();
    window.axios.post(api.password.reset, this.state)
      .then(({ data: { status } }) => {
        this.setState({ 'resetMessage': status });
      }).catch(error => {
        this.setState({ errors: destructServerErrors(error) });
      });
  }

  handleInputChange (e) {
    this.setState({
      [e.target.name]: e.target.value,
      errors: {
        ...this.state.errors,
        ...{ [e.target.name]: '' }
      }
    });
  }

  componentDidMount () {
    this.setState({
      'token': this.props.match.params.token
    });
    
    document.body.classList.add('bg-green-gradient','d-flex', 'flex-column', 'mh-100vh', 'justify-content-center');
  }

  componentWillUnmount () {
    document.body.classList.remove(... document.body.classList);
  }

  render () {
    return (
      <DocumentTitle title={`${__('app.reset_password.title')} - ${window.App.name}`}>
        <div className="container">
          <div className="row">
            <div className="col-md-6 offset-md-3 col-12">
              <h2 className="text-white">{ __('app.reset_password.title') }</h2>
              {
                this.state.resetMessage !== '' && (
                <div className="alert alert-info font-size-18 font-weight-bold" role="alert">
                  {this.state.resetMessage}
                </div>
                )
              }
              <form onSubmit={e => this.handleSubmit(e)} method="POST">
                <div className="form-label-group">
                  <input
                    value={this.state.email}
                    onChange={e => this.handleInputChange(e)}
                    id="email"
                    type="email"
                    name="email"
                    className={`form-control ${hasError(this.state.errors, 'email') ? 'border-orange' : ''}`}
                    placeholder={ __('app.reset_password.email') } 
                    required
                    autoFocus
                  />
                  <label htmlFor="email">{ __('app.reset_password.email') }</label>
                  {
                    hasError(this.state.errors, 'email') &&
                    <div className="mt-3">
                      <FormError>{getError(this.state.errors, 'email')}</FormError>
                    </div>
                  }
                </div>
                <div className="form-label-group">
                  <input
                    value={this.state.password}
                    onChange={e => this.handleInputChange(e)}
                    id="password"
                    type="password"
                    name="password"
                    placeholder=""
                    className={`form-control ${hasError(this.state.errors, 'password') ? 'border-orange' : ''}`}
                    required
                  />
                  <label htmlFor="password">{ __('app.reset_password.password') }</label>
                  {
                    hasError(this.state.errors, 'password') &&
                    <div className="mt-3">
                      <FormError>{getError(this.state.errors, 'password')}</FormError>
                    </div>
                  }
                </div>
                <div className="form-label-group">
                  <input
                    value={this.state.password_confirmation}
                    onChange={e => this.handleInputChange(e)}
                    id="password-confirmation"
                    type="password"
                    name="password_confirmation"
                    placeholder=""
                    className={`form-control ${hasError(this.state.errors, 'password') ? 'border-orange' : ''}`}
                    required
                  />
                  <label htmlFor="password-confirmation">{ __('app.reset_password.password_confirm') }</label>
                </div>
                <input type="submit" className="btn btn-black d-block w-100 light-shadow mb-3" value={ __('app.reset_password.button') } />
                <Link to="/" className="btn btn-link text-white mt-2"> { __('app.reset_password.to_login') }</Link>
              </form>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

ResetPassword.propTypes = propTypes;

export default ResetPassword;
